import Axios from "axios";
import { NETWORK_ERROR } from "@/constants/errorCode";
import { ACCESS_PAYLOAD_KEY, BASE_API_PREFIX, BASE_API_URL } from "@/constants/defaultValue";

const apis = Axios.create({
  baseURL: `${BASE_API_URL}/${BASE_API_PREFIX}`,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

apis.interceptors.request.use(
  (config) => {
    config.headers[ACCESS_PAYLOAD_KEY] = localStorage.getItem(ACCESS_PAYLOAD_KEY);

    const managerAccessToken = sessionStorage.getItem("manager_access_token");
    if (managerAccessToken) {
      config.headers["ManagerAccessToken"] = managerAccessToken;
    }

    const sessionToken = sessionStorage.getItem("session_token");
    if (sessionToken) {
      config.headers["sSMid"] = sessionToken;
    }

    const business = sessionStorage.getItem("business") || localStorage.getItem("business");
    if (business) {
      if (!config.params) config.params = {};
      if (!config.params.business) {
        config.params.business = business;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

apis.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalConfig = error.config;
    const errorResult = getResponseError(error);

    // if ((error.response?.status === 401 && originalConfig.url === `${BASE_API_URL}/${BASE_API_PREFIX}/auth/login`) || originalConfig.url === `${BASE_API_URL}/${BASE_API_PREFIX}/auth/refresh`) {
    //   return Promise.reject(errorResult);
    // }

    // if (error.response?.status === 401 && !originalConfig._retry) {
    //   originalConfig._retry = true;
    //   try {
    //     const refreshTokenPayload$ = localStorage.getItem("x-refresh-payload");

    //     if (!refreshTokenPayload$) throw new Error("Missing refresh token");

    //     const { accessTokenPayload, refreshTokenPayload } = await axios.get(`${BASE_API_URL}/${BASE_API_PREFIX}/auth/refresh`, {
    //       headers: {
    //         "Content-Type": "application/json",
    //         [`${REFRESH_PAYLOAD_KEY}`]: refreshTokenPayload$,
    //       },
    //     });
    //     localStorage.setItem(REFRESH_PAYLOAD_KEY, refreshTokenPayload);
    //     localStorage.setItem(ACCESS_PAYLOAD_KEY, accessTokenPayload);
    //     return axios(originalConfig);
    //   } catch (error) {
    //     const errorResult = getResponseError(error);
    //     return Promise.reject(errorResult);
    //   }
    // }
    return Promise.reject(errorResult);
  }
);

export function getResponseError(error) {
  if (error.response) {
    return {
      ...error.response.data,
      message: error.response.data.message || error.response.data.error,
      statusCode: error.response?.status || error.response.data.statusCode,
    };
  }

  if (error.message === "Network Error") {
    return {
      statusCode: 500,
      errorCode: NETWORK_ERROR,
      message: error.message,
    };
  }

  return {
    statusCode: 555,
    errorCode: "unknow_platform_error",
    message: error.message,
  };
}

export default apis;
